/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// component
import Sites from 'pages/dashboard/account/sites/sites';



/* ========== ~~~~~~~~~~ ACCOUNT SITES : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ( { homeState, accountData, sessionStatus } ) =>({
    sites: accountData.sites,
    accountUUID: sessionStatus.accountUUID
});

// map actions
const mapDispatchToProps = dispatch => ({
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Sites);
